const keyWords = {
  DUMMY_TASK: "DummyTask",
};
export default keyWords;
